import { QrReader } from "react-qr-reader";
import { CameraQRReaderErrors, CameraQRReaderProps } from "./CameraQRReader.types";
import { Result } from "@zxing/library";
import CameraQRReaderDisplay from "./CameraQRReaderDisplay/CameraQRReaderDisplay";
import { CameraQRReaderRoot, VIDEO_CONTAINER_STYLES } from "./CameraQRReader.styles";
import clsx from "clsx";

function CameraQRReader({ className, onScan, onError, onPermissionDeniedError, cameraPosition = "back", ...rest }: CameraQRReaderProps) {
    const facingMode = cameraPosition === "back" ? "environment" : "user";

    function handleOnResult(res: Result | null | undefined, err: Error | null | undefined) {
        if (res) {
            onScan?.(res.getText());
        } else if (err?.message) {
            if (err.message === CameraQRReaderErrors.PERMISSION_DENIED) {
                onPermissionDeniedError?.(err);
            }
            onError?.(err);
        }
    }

    return (
        <CameraQRReaderRoot className={clsx("camera-qr-reader", className)} {...rest}>
            <QrReader
                onResult={handleOnResult}
                videoId="camera-qr-reader-video"
                scanDelay={500}
                ViewFinder={CameraQRReaderDisplay}
                constraints={{ facingMode }}
                videoStyle={{ objectFit: "cover" }}
                videoContainerStyle={VIDEO_CONTAINER_STYLES}
            />
        </CameraQRReaderRoot>
    );
}

export default CameraQRReader;
